import React from 'react';
import PropTypes from 'prop-types';

const SendIcon = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Send"
  >
    <path d="M3 11.75L20.4 3.4C21.183 3.024 21.977 3.817 21.601 4.6L13.25 22C12.905 22.718 11.85 22.631 11.627 21.87L9.457 14.462L2.13 12.373C1.369 12.15 1.282 11.095 2 10.75L20.4 3.4" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
  </svg>
);

SendIcon.propTypes = {
  className: PropTypes.string
};

SendIcon.defaultProps = {
  className: ''
};

export default SendIcon;
